import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-4 grid grid-cols-1 auto-rows-min sm:grid-cols-1 gap-4 custom-height" }
const _hoisted_2 = {
  key: 0,
  class: "p-8 bg-white shadow"
}
const _hoisted_3 = { class: "text-2xl mb-8" }
const _hoisted_4 = { class: "grid sm:grid-cols-2 lg:grid-cols-4 gap-4 text-sm" }
const _hoisted_5 = { class: "text-2xl mb-8" }
const _hoisted_6 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" }
const _hoisted_7 = { class: "w-96" }
const _hoisted_8 = { class: "flex-grow mb-6" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "block w-full mb-1" }
const _hoisted_11 = {
  key: 0,
  class: "loading-element flex items-center justify-center transition-all duration-1000 ease-in-out"
}
const _hoisted_12 = { class: "relative z-30 text-3xl text-gray-600 capitalize animate-pulse" }
const _hoisted_13 = {
  key: 1,
  class: "max-h-max-content"
}
const _hoisted_14 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_15 = { class: "w-full text-sm text-left table-auto" }
const _hoisted_16 = { class: "bg-nucleus-primaryBlue text-white sticky top-0" }
const _hoisted_17 = { class: "px-4 py-3 z-10" }
const _hoisted_18 = { class: "px-4 py-3 z-10" }
const _hoisted_19 = { class: "px-4 py-3 z-10" }
const _hoisted_20 = { class: "px-4 py-3 z-10" }
const _hoisted_21 = { class: "px-4 py-3 z-10" }
const _hoisted_22 = { class: "nucleus-table-body" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "px-4 py-3" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "px-4 py-3" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "px-4 py-3" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "px-4 py-3" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "px-4 py-3" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  colspan: "5",
  class: "px-4 py-4"
}
const _hoisted_35 = {
  key: 0,
  class: "grid sm:grid-cols-2 lg:grid-cols-3 gap-6 text-sm"
}
const _hoisted_36 = { class: "font-semibold mb-1" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = { key: 4 }
const _hoisted_42 = { key: 5 }
const _hoisted_43 = { class: "font-semibold mb-1" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "font-semibold mb-1" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 2,
  class: "text-center text-gray-500"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_ErrorBox = _resolveComponent("ErrorBox")!
  const _component_InfoItem = _resolveComponent("InfoItem")!
  const _component_Select = _resolveComponent("Select")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_ButtonOutlined = _resolveComponent("ButtonOutlined")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_LoadingScreen, {
      loaded: _ctx.loaded,
      message: _ctx.loadingMessage
    }, null, 8, ["loaded", "message"]),
    (_ctx.errorHeading || _ctx.errorContent)
      ? (_openBlock(), _createBlock(_component_ErrorBox, {
          key: 0,
          heading: _ctx.errorHeading,
          content: _ctx.errorContent,
          fixed: _ctx.errorFixed,
          onCloseError: _cache[0] || (_cache[0] = ($event: any) => {
        _ctx.errorHeading = '';
        _ctx.errorContent = '';
      })
        }, null, 8, ["heading", "content", "fixed"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("pages.usage.allowanceTitle")), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('pages.usage.currentLicense'),
                value: _ctx.usage.license
              }, null, 8, ["heading", "value"]),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('pages.usage.licenseExpiry'),
                value: _ctx.getPrettyDate(_ctx.usage.licenseExpiry)
              }, null, 8, ["heading", "value"]),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('pages.usage.hoursUsed'),
                value: _ctx.getHoursUsed()
              }, null, 8, ["heading", "value"]),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('pages.usage.currentBalance'),
                value: _ctx.getHoursLeft(),
                "no-padding": true
              }, null, 8, ["heading", "value"])
            ]),
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("pages.usage.usageHistory")), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Select, {
                  id: "ors",
                  value: _ctx.selectedRange,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedRange) = $event)),
                  label: _ctx.$t('pages.usage.dateRange'),
                  options: _ctx.rangeOptions,
                  onChange: _ctx.onRangeChange
                }, null, 8, ["value", "label", "options", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.selectedRange === 'custom')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("pages.usage.dateRanges.custom")), 1),
                      _createVNode(_component_VueDatePicker, {
                        modelValue: _ctx.date,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
                          _ctx.updateUsageHistory
                        ],
                        range: "",
                        "multi-calendars": { solo: true },
                        class: "w-96",
                        "format-locale": _ctx.datePickerLocale,
                        format: "P HH:mm"
                      }, null, 8, ["modelValue", "format-locale", "onUpdate:modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.usageHistory?.usageEvents?.length)
                ? (_openBlock(), _createBlock(_component_ButtonOutlined, {
                    key: 0,
                    type: "button",
                    name: _ctx.$t('pages.usage.exportAsCsv'),
                    class: "w-max px-6",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportAsCSV()))
                  }, null, 8, ["name"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.usageHistoryLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("pages.usage.loadingUsageData")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.usageHistory?.usageEvents?.length && !_ctx.usageHistoryLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_ctx.date)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.getPrettyDateTime(_ctx.date[0]) + " - " + _ctx.getPrettyDateTime(_ctx.date[1])), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("table", _hoisted_15, [
                    _createElementVNode("thead", _hoisted_16, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("pages.usage.table.columns.timestamp")), 1),
                        _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("pages.usage.table.columns.type")), 1),
                        _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t("pages.usage.table.columns.duration")), 1),
                        _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("pages.usage.table.columns.credits")), 1),
                        _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("pages.usage.table.columns.balance")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageHistory.usageEvents, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.eventId
                        }, [
                          _createElementVNode("tr", {
                            class: _normalizeClass(["cursor-pointer relative", 
                    _ctx.expandedRows[item.eventId]
                      ? 'border-2 border-nucleus-primaryBlue border-b-0 active'
                      : 'border-2 border-transparent border-b-0'
                  ]),
                            onClick: ($event: any) => (_ctx.toggleRow(item))
                          }, [
                            _createElementVNode("td", _hoisted_24, [
                              (item.timestamp)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.getPrettyDateTime(item.timestamp)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_26, [
                              (item.eventType)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.formatEventType(item.eventType)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_28, [
                              (item.sessionDuration)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.formatDuration(item.sessionDuration)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_30, [
                              (item.credits)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.formatCreditsChange(item.eventType, item.credits)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              (item.credits)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.formatCredits(item.balance)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 10, _hoisted_23),
                          _withDirectives(_createElementVNode("tr", {
                            class: _normalizeClass(["bg-nucleus-listBgActive", 
                    _ctx.expandedRows[item.eventId]
                      ? 'border-2 border-nucleus-primaryBlue border-t-0'
                      : 'border-2 border-transparent border-t-0'
                  ])
                          }, [
                            _createElementVNode("td", _hoisted_34, [
                              (item.session)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("pages.usage.details.sessionDetails")), 1),
                                      (item.session.roomName)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.$t("pages.usage.details.room")) + " " + _toDisplayString(item.session.roomName), 1))
                                        : _createCommentVNode("", true),
                                      (item.session.department)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.$t("pages.usage.details.department")) + " " + _toDisplayString(item.session.department), 1))
                                        : _createCommentVNode("", true),
                                      (item.session.startedAt)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.$t("pages.usage.details.startedAt")) + " " + _toDisplayString(_ctx.getPrettyDateTime(item.session.startedAt)), 1))
                                        : _createCommentVNode("", true),
                                      (item.session.endedAt)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.$t("pages.usage.details.endedAt")) + " " + _toDisplayString(_ctx.getPrettyDateTime(item.session.endedAt)), 1))
                                        : _createCommentVNode("", true),
                                      (item.session.endedAt)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.$t("pages.usage.details.duration")) + " " + _toDisplayString(_ctx.formatDuration(item.sessionDuration)), 1))
                                        : _createCommentVNode("", true),
                                      (item.credits)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.$t("pages.usage.details.creditsUsed")) + " " + _toDisplayString(_ctx.formatCredits(item.credits)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("pages.usage.details.userDetails")), 1),
                                      (item.session.createdBy)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.$t("pages.usage.details.createdBy")) + " " + _toDisplayString(item.session.createdBy), 1))
                                        : _createCommentVNode("", true),
                                      (item.session.startedBy)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.$t("pages.usage.details.startedBy")) + " " + _toDisplayString(item.session.startedBy), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (
                          item.session.joinedUsers &&
                          item.session.joinedUsers.length
                        )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                          _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("pages.usage.details.participants")), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.session.joinedUsers, (user) => {
                                            return (_openBlock(), _createElementBlock("div", { key: user }, _toDisplayString(user), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.$t("pages.usage.details.noData")), 1))
                            ])
                          ], 2), [
                            [_vShow, _ctx.expandedRows[item.eventId]]
                          ])
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  (!_ctx.date)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.$t("pages.usage.selectDateRange")), 1))
                    : _createCommentVNode("", true),
                  (_ctx.date && !_ctx.usageHistoryLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.$t("pages.usage.noData")), 1))
                    : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}